import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';
import { BUSINESSPLAN } from '../../../routes';
import './styles.css';

class Button extends Component {
	render() {
		const { businessPlanID, gameID } = this.props;
		return (
			<NavLink
				to={formatRoute(BUSINESSPLAN, { businessPlanID, gameID })}
				className="stepper-item-layout-button"
			>
				REVIEW
			</NavLink>
		);
	}
}

export default Button;
